import { EnumTipoFaturamentoSistema } from "model/enums/enum-tipo-faturamento-sistema";

export class NovoSistemaCadastroFormModel {
    constructor(
        public nome: string = '',
        public descricao: string = '',
        public urlImagem: string = '',
        public permiteMultiContratos: boolean = false,
        public tipoFaturamento: EnumTipoFaturamentoSistema = EnumTipoFaturamentoSistema.Padrao,
    ) { }
}